export const randomId = () => {
  const min = 100000;
  const max = 1000000; // Exclusive
  return Math.floor(Math.random() * (max - min) + min).toString();
};

export const advancedRandomId = (length: number) => {
  return new Array(length).fill("").map(randomId).join("-");
};
